// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.helpScreen {
  flex: 1 1;
  display: flex;
  background-color: #f3f4f6;
}
.helpScreen .helpContainer {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.helpScreen .header {
  text-align: center;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 41px;
  margin-bottom: 43px;
}
.helpScreen .arrow {
  height: 32px;
  width: 32px;
  rotate: 90deg;
  cursor: pointer;
  position: relative;
  top: 11px;
}
.helpScreen .helpItem {
  height: 111px;
  width: 576px;
  margin-bottom: 18px;
  padding: 32px;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 26px;
  display: flex;
  justify-content: space-between;
  background: #ffffff;
  border: 1px solid #e9e9e9;
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  cursor: pointer;
}
.helpScreen .helpItem .title {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: #333333;
}
.helpScreen .helpItem .subTitle {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #868686;
}
.helpScreen .helpItem .imageContainer {
  display: inline-block;
  position: relative;
  top: 4px;
}
.helpScreen .helpItem .textContainer {
  display: inline-block;
  margin-left: 22px;
}`, "",{"version":3,"sources":["webpack://./src/screens/help/Help.scss"],"names":[],"mappings":"AAAA;EACI,SAAA;EACA,aAAA;EACA,yBAAA;AACJ;AACI;EACI,SAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AACR;AAEI;EACI,kBAAA;EACA,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AAAR;AAGI;EACI,YAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;AADR;AAII;EACI,aAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,yBAAA;EACA,4CAAA;EACA,kBAAA;EACA,eAAA;AAFR;AAIQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAFZ;AAKQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAHZ;AAMQ;EACI,qBAAA;EACA,kBAAA;EACA,QAAA;AAJZ;AAMQ;EACI,qBAAA;EACA,iBAAA;AAJZ","sourcesContent":[".helpScreen {\n    flex: 1;\n    display: flex;\n    background-color: #f3f4f6;\n\n    .helpContainer {\n        flex: 1;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n    }\n\n    .header {\n        text-align: center;\n        font-family: 'Noto Sans KR';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 28px;\n        line-height: 41px;\n        margin-bottom: 43px;\n    }\n\n    .arrow {\n        height: 32px;\n        width: 32px;\n        rotate: 90deg;\n        cursor: pointer;\n        position: relative;\n        top: 11px;\n    }\n\n    .helpItem {\n        height: 111px;\n        width: 576px;\n        margin-bottom: 18px;\n        padding: 32px;\n        font-family: 'Noto Sans KR';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 18px;\n        line-height: 26px;\n        display: flex;\n        justify-content: space-between;\n        background: #ffffff;\n        border: 1px solid #e9e9e9;\n        box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);\n        border-radius: 8px;\n        cursor: pointer;\n\n        .title {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 18px;\n            line-height: 24px;\n            color: #333333;\n        }\n\n        .subTitle {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 14px;\n            line-height: 20px;\n            color: #868686;\n        }\n\n        .imageContainer {\n            display: inline-block;\n            position: relative;\n            top: 4px;\n        }\n        .textContainer {\n            display: inline-block;\n            margin-left: 22px;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
